import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { makeGetIsParent } from "~/store/selectors/selector.taskDependencies.jsx";
import { getDefaultTaskById, makeIsTaskFromRecurringSelector } from "~/store/selectors/selector.tasks.jsx";
import { hasLoggedUserElevatedPermissions } from "~/store/selectors/selector.users.jsx";
import TaskListItem from "./component.task_list_item.jsx";

export const TaskListItemContainer = ({
  id,
  isDependency,
  taskDependencyId,
  showConflict,
  isAssigneeHidden,
  isProjectNameVisible,
  onStartEdit,
  editMode,
  onCancelEdit,
}) => {
  const isTaskFromRecurring = useMemo(makeIsTaskFromRecurringSelector, []);
  const task = useSelector((state) => getDefaultTaskById(state, id));
  const getIsParent = useMemo(makeGetIsParent, []);
  const isParent = useSelector((state) => getIsParent(state, taskDependencyId, id));
  const canEdit = useSelector(hasLoggedUserElevatedPermissions);
  const fromRecuring = useSelector((state) => isTaskFromRecurring(state, id));

  if (!task.task_list_id) return null;

  return (
    <TaskListItem
      id={id}
      taskListId={task.task_list_id}
      projectId={task.project_id}
      completedOn={task.completed_on}
      completed={task.is_completed}
      important={task.is_important}
      pending={task._pending}
      fromRecuring={fromRecuring}
      isParent={isParent}
      canEdit={canEdit}
      isDependency={isDependency}
      showConflict={showConflict}
      isAssigneeHidden={isAssigneeHidden}
      isProjectNameVisible={isProjectNameVisible}
      onStartEdit={onStartEdit}
      editMode={editMode}
      onCancelEdit={onCancelEdit}
      taskDependencyId={taskDependencyId}
    />
  );
};

TaskListItemContainer.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string, // string is used as placeholder ID until backend returns the real ID
    PropTypes.number,
  ]).isRequired,
  taskDependencyId: PropTypes.number,
  editMode: PropTypes.bool,
  onStartEdit: PropTypes.func,
  onCancelEdit: PropTypes.func,
  isDependency: PropTypes.bool,
  showConflict: PropTypes.bool,
  isAssigneeHidden: PropTypes.bool,
  isProjectNameVisible: PropTypes.bool,
};

TaskListItemContainer.defaultProps = {
  taskDependencyId: 0,
  editMode: false,
  isDependency: false,
  showConflict: false,
  isAssigneeHidden: false,
  isProjectNameVisible: false,
};

TaskListItemContainer.displayName = "TaskListItemContainer";

export default TaskListItemContainer;
